import { useGuidedToursEventTracking } from "@features/GuidedTours/useGuidedToursEventTracking";
import { useThreadsStore } from "@store/threads.store";
import { useMemo } from "react";
import { threadAutoInteractionConfig } from "../chat-thread-auto-interaction-config";
import { useWelcomeChatThreadFlow } from "./useWelcomeChatThreadFlow";

type Props = {
  currentThread: string | undefined;
  numberOfMessages: number;
  isSendingMessage: boolean;
  isReceivingMessageResponse: boolean;
};

export const useThreadAutoInteraction = ({
  currentThread,
  numberOfMessages,
  isSendingMessage,
  isReceivingMessageResponse,
}: Props) => {
  const threads = useThreadsStore((state) => state.threads);

  const config = useMemo(() => {
    if (!currentThread) return null;
    const thread = threads.find((t) => t.id === currentThread);
    if (!thread) return null;
    if (thread.metadata && thread.metadata["flowType"] === "welcome") {
      return threadAutoInteractionConfig["welcome"];
    }
    return null;
  }, [threads, currentThread]);

  const {
    isMessageBarOverlayHidden,
    hasMoreAutoInteractions,
    nextMessageIndex,
    handleFinishAutoTyping,
  } = useWelcomeChatThreadFlow({
    threadAutoInteractionConfig: config,
    numberOfMessages,
    isSendingMessage,
    isReceivingMessageResponse,
  });

  useGuidedToursEventTracking();

  return {
    threadAutoInteractionConfig: config,
    isMessageBarOverlayHidden,
    hasMoreAutoInteractions,
    nextMessageIndex,
    handleFinishAutoTyping,
  };
};
